import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CaseStudyCard = ({ caseStudy, onViewDetails }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="bg-card rounded-lg overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300 flex flex-col h-full">
      <div className="relative h-48 md:h-56 lg:h-64 overflow-hidden">
        <Image
          src={caseStudy?.image}
          alt={caseStudy?.imageAlt}
          className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
        />
        <div className="absolute top-4 left-4 flex flex-wrap gap-2">
          <span className="px-3 py-1 bg-primary text-primary-foreground text-xs font-medium rounded-full">
            {caseStudy?.industry}
          </span>
          <span className="px-3 py-1 bg-accent text-accent-foreground text-xs font-medium rounded-full">
            {caseStudy?.service}
          </span>
        </div>
      </div>
      <div className="p-4 md:p-6 flex-1 flex flex-col">
        <div className="flex items-start justify-between mb-3">
          <div className="flex-1">
            <h3 className="text-lg md:text-xl font-bold text-foreground mb-2 line-clamp-2">
              {caseStudy?.company}
            </h3>
            <p className="text-sm text-muted-foreground">{caseStudy?.location}</p>
          </div>
          <div className="w-12 h-12 md:w-14 md:h-14 rounded-lg bg-muted flex items-center justify-center flex-shrink-0 ml-3">
            <Image
              src={caseStudy?.logo}
              alt={caseStudy?.logoAlt}
              className="w-8 h-8 md:w-10 md:h-10 object-contain"
            />
          </div>
        </div>

        <div className="mb-4">
          <h4 className="text-sm font-semibold text-foreground mb-2">Challenge</h4>
          <p className="text-sm text-muted-foreground line-clamp-2">
            {caseStudy?.challenge}
          </p>
        </div>

        {isExpanded && (
          <div className="mb-4 space-y-4">
            <div>
              <h4 className="text-sm font-semibold text-foreground mb-2">Solution</h4>
              <p className="text-sm text-muted-foreground">
                {caseStudy?.solution}
              </p>
            </div>

            <div className="grid grid-cols-2 gap-3">
              {caseStudy?.results?.map((result, index) => (
                <div key={index} className="bg-muted rounded-lg p-3">
                  <div className="flex items-center gap-2 mb-1">
                    <Icon name={result?.icon} size={16} className="text-success" />
                    <span className="text-lg md:text-xl font-bold text-foreground">{result?.value}</span>
                  </div>
                  <p className="text-xs text-muted-foreground">{result?.label}</p>
                </div>
              ))}
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground mb-2">Timeline</h4>
              <div className="flex items-center gap-2 text-sm text-muted-foreground">
                <Icon name="Calendar" size={16} />
                <span>{caseStudy?.timeline}</span>
              </div>
            </div>
          </div>
        )}

        <div className="mt-auto pt-4 border-t border-border flex items-center justify-between gap-3">
          <Button
            variant="ghost"
            size="sm"
            iconName={isExpanded ? "ChevronUp" : "ChevronDown"}
            iconPosition="right"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? 'Show Less' : 'Show More'}
          </Button>
          <Button
            variant="outline"
            size="sm"
            iconName="ExternalLink"
            iconPosition="right"
            onClick={() => onViewDetails(caseStudy)}
          >
            Full Story
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CaseStudyCard;